module.exports = __webpack_public_path__ + "img/content4.592910ba.png";